import { render, staticRenderFns } from "./DependencyUpdates.vue?vue&type=template&id=7a3cc887&"
import script from "./DependencyUpdates.vue?vue&type=script&lang=js&"
export * from "./DependencyUpdates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports